<template>
  <div class="panel box">
    <div
      class="box-header with-border"
      data-toggle="collapse"
      data-parent="#accordion"
      :href="`#${id}`"
    >
      <h4 class="box-title">
        <span v-text="title" />
      </h4>
    </div>
    <div
      :id="id"
      class="collapse"
    >
      <div class="box-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionItem',
  props: {
    /**
     * Индекс элемента.
     */
    index: {
      type: Number,
      required: true
    },
    /**
     * Заголовок.
     */
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * Идентификатор элемента.
     *
     * @returns {string}
     */
    id () {
      return `collapse${this.index}`
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  border: none;
  background-color: #fbfbfb;

  .box-header {
    cursor: pointer;
  }
}
</style>
